class TitreBandeauController {
  constructor() {
    console.log('titre-bandeau');
  }
}

TitreBandeauController.$inject = [];

module.exports = TitreBandeauController;



// WEBPACK FOOTER //
// ./src/app/components/titre-bandeau/titre-bandeau.controller.js